// src/features/schedule/constants/quickCreate.constants.ts
import { TimeBoxCategory } from '../../../types/timeBox';
import { EventCategory } from '../../../types/calendar-event';

// Quick Create 的 TimeBox 類別（全部 4 種）
export const QUICK_CREATE_TIMEBOX_CATEGORIES: TimeBoxCategory[] = [
  'focus',
  'routine',
  'life',
  'rest'
];

// Quick Create 的 Event 類別（最常用的 4 種）
export const QUICK_CREATE_EVENT_CATEGORIES: EventCategory[] = [
  'meeting',
  'appointment',
  'class',
  'other'
];

// TimeBox 時長選項（分鐘）
export const TIMEBOX_DURATION_OPTIONS = [15, 30, 60, 90, 120, 180] as const;

// Event 時長選項（分鐘 + All Day）
export const EVENT_DURATION_OPTIONS = [15, 30, 60, 90, 120, 180, 'allday'] as const;

export type DurationOption = typeof TIMEBOX_DURATION_OPTIONS[number];
export type EventDurationOption = typeof EVENT_DURATION_OPTIONS[number];

// Quick Create 通用時長型別（支援 TimeBox 和 Event）
export type QuickCreateDuration = number | 'allday';
